import React from "react";
import { Button, Row, Spinner } from "react-bootstrap";
import AdminAllProductsCard from "./AdminAllProductsCard";
import { Link } from "react-router-dom";
const AdminAllProductComp = ({ allProductsresponse, loading, searchValue, handleChangeSearchValue }) => {
  return (
    <>
      <div className='d-flex flex-row justify-content-between m-3  mt-5 align-items-center'>
        <h3 className='fw-bold'>All Products</h3>
        <Link to="/admin/addproduct">
          <Button className='dark-bg border-0 px-4 py-3'>Add New Product</Button>
        </Link>
      </div>
      <div className='d-flex flex-row justify-content-between mx-3 align-items-center mb-5'>
        <input type='text' className='form-control h-60 fs-20 fw-bold' placeholder='Search by product Name' value={searchValue} onChange={handleChangeSearchValue} />
      </div>
      <Row className="justify-content-start mx-1">

        {loading === true ?
          (<div className='d-flex justify-content-center align-items-center mt-5 pt-5'> <Spinner animation="border" variant="danger" /></div>)
          :
          (allProductsresponse && allProductsresponse.length > 0 ? (allProductsresponse.map((item, index) => { return (<AdminAllProductsCard key={index} allProductsresponse={item} />) }))
            :
            (
              <div className='d-flex justify-content-center align-items-center flex-column h-100'>
                <h3 className='alert alert-danger'>No Products, Add new Product to show</h3>
                <Link to="/admin/addproduct">
                  <Button className='dark-bg border-0 px-4 py-3'>Add New Product</Button>
                </Link>
              </div>
            )
        )}
      </Row>
    </>
  );
};

export default AdminAllProductComp;
